import { contractServiceClient } from '@lib/documentServiceClient';
import { createEnvelopeService } from '@workpay/ds-shared/services/envelopeService';

export const dsEnvelopeService = createEnvelopeService(contractServiceClient);

// Workpay-admin-only — wizard's Send-for-Review prefill. Lives outside the
// shared `@workpay/ds-shared/envelopeService` factory because external recipients
// (ds-external app, token-based auth) never hold `ENVELOPES_CREATE` and never
// open the authoring wizard, so this endpoint is meaningless to them.
export interface ReviewPrefillContact {
  name: string | null;
  email: string | null;
}

export interface ReviewPrefillData {
  /**
   * Flat reviewer list, position-significant: `reviewers[0]` is the envelope's
   * target employee (contract subject), subsequent entries are the union of
   * default reviewers configured on every source template referenced by the
   * envelope's documents — deduped on `lower(email)`. Always non-null and
   * contains at least the employee block.
   */
  reviewers: ReviewPrefillContact[];
}

export async function getReviewPrefill(envelopeId: string): Promise<ReviewPrefillData> {
  const res = await contractServiceClient.get<ReviewPrefillData>(
    `/v1/envelopes/${envelopeId}/review-prefill`,
  );
  return res.data;
}

// Wizard Step 1 prefill — admin-only, kept out of the shared factory. See FEATURE.md.
export interface RecipientPrefillSigner {
  name: string | null;
  email: string | null;
  signingOrder: number;
}

export interface RecipientPrefillData {
  signers: RecipientPrefillSigner[];
  cc: string[] | null;
  bcc: string[] | null;
}

export async function getRecipientPrefill(envelopeId: string): Promise<RecipientPrefillData> {
  const res = await contractServiceClient.get<RecipientPrefillData>(
    `/v1/envelopes/${envelopeId}/recipient-prefill`,
  );
  return res.data;
}
